module.exports = __webpack_public_path__ + "img/31.b0c0a5a1.jpg";